import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What items do you accept?',
      answer: 'We take furniture, appliances, boxes, yard debris, and most household items. Sorry, no hazardous materials like chemicals, paint, or asbestos. If you\'re unsure about a specific item, just give us a call and we\'ll let you know!'
    },
    {
      question: 'Do you offer same-day service?',
      answer: 'Yes! We prioritize same-day or next-day scheduling whenever possible. Call us in the morning, and we can often have a crew at your location the same afternoon. Availability depends on our schedule, so contact us early for the best chance of same-day service.'
    },
    {
      question: 'How do you price jobs?',
      answer: 'We charge based on truck size: 1/4, 1/2, 3/4, or full truck. Prices are upfront and transparent - no hidden fees. Our crew will assess your items and give you an exact quote before we start loading. You only pay for the space your junk takes up in our truck.'
    },
    {
      question: 'Are your crews professional?',
      answer: 'Absolutely. All crews are experienced, insured, and respectful. Our team members undergo background checks and are trained to handle your property with care. We treat your home or business as if it were our own.'
    },
    {
      question: 'How do I pay?',
      answer: 'Cash, credit card, or online payment - whatever works best for you. We accept all major credit cards including Visa, Mastercard, American Express, and Discover. Payment is due upon completion of the job.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif text-[#2C2C2C] mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-[#6B7280]">Everything you need to know</p>
        </div>

        {/* Accordion List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl transition-all duration-300 ${
                openIndex === index 
                  ? 'border-2 border-[#FF6B4A] shadow-lg' 
                  : 'border border-[#E5E7EB] hover:border-2 hover:border-[#FF6B4A]'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-lg font-bold text-[#2C2C2C] pr-4">{faq.question}</span>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className={`ri-add-line text-2xl text-[#FF6B4A]`}></i>
                </div>
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6 pt-0">
                  <p className="text-[#6B7280] leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 pt-12 border-t border-[#E5E7EB]">
          <p className="text-[#6B7280] mb-6">Still have questions?</p>
          <a 
            href="tel:+18435551234" 
            className="inline-flex items-center gap-2 bg-[#FF6B4A] text-white px-8 py-4 rounded-full hover:bg-[#ff5533] transition-all whitespace-nowrap text-base font-semibold"
          >
            <i className="ri-phone-fill"></i>
            Give Us a Call
          </a>
        </div>
      </div>
    </section>
  );
}
